import { uniqBy } from 'lodash-es';
import type { ListOffer } from '~/lib/goliath/offers';
import type { ScopedOffer, LocalAttachment } from '~/lib/goliath/goliath.types';
import { getGoliathImages, type LocalImage } from '@i22/rocket';

export const getImagesFromOffer = <O extends ListOffer | ScopedOffer>(offer: O): LocalImage[] => {
  if (!offer) return [];
  const baseImages: LocalAttachment[] = [];
  if ('media' in offer && offer.media) {
    offer.media.forEach((media) => {
      if (media && media.remote === false) {
        baseImages.push(media as LocalAttachment);
      }
    });
  }
  if (
    baseImages.length === 0 &&
    offer.product &&
    'teaserImage' in offer.product &&
    !offer.product.teaserImage?.remote
  ) {
    baseImages.push(offer.product.teaserImage as LocalAttachment);
  }
  // const baseImages = 'media' in offer ? offer?.media || [] : [];
  const product = offer?.product || {};
  const bundledProducts = 'bundledProducts' in product ? product.bundledProducts || [] : [];
  const additionalImages = bundledProducts.map((i) => i?.teaserImage);
  const uniqueAdditionalImages = uniqBy(additionalImages, 'mediaId');

  return getGoliathImages({
    // @ts-ignore
    media: [...baseImages, ...uniqueAdditionalImages],
  });
};

export const getMainImageFromOffer = <O extends ListOffer | ScopedOffer>(
  offer: O | undefined,
  index = 0
) => {
  if (!offer) return undefined;
  const offerImages = getImagesFromOffer(offer);
  if (offerImages.length < index + 1) return undefined;
  return offerImages[index];
};
